import React from 'react';
import { DOMAIN_NAME, DOMAIN_URL } from './DomainConfig';

import Import from '../pages/system/import/Import';
import TermsPrivacy from '../pages/terms-privacy/TermsPrivacy';
import Tutorials from '../pages/system/tutorials/Tutorials';
import ChangelogPage from '../pages/system/changelog/ChangelogPage';
import Notifications from '../pages/notifications/Notifications';
import MassMessaging from '../pages/marketing/mass-messaging/MassMessaging';
import Campaigns from '../pages/marketing/campaigns/Campaigns';
import Sources from '../pages/marketing/sources/Sources';
import Export from '../pages/system/export/Export';
import About from '../pages/system/about/About';
import Login from '../pages/login/Login';
import Leads from '../pages/leads/Leads';
import WhatsappMessages from '../pages/whatsappMessages/WhatsappMessages';
import Dashboard from '../pages/dashboard/Dashboard';
import Appointments from '../pages/appointments/Appointments';
import Appointment from '../pages/appointment/Appointment';
import WaitingListV2Page from '../pages/waiting-list-v2/WaitingListV2Page';
import RecoveryPage from '../pages/intelligence/recovery/RecoveryPage';
import Invoice from '../pages/invoice/Invoice';
import Document from '../pages/document/Document';
import Patients from '../pages/patients/Patients';
import Patient from '../pages/patient/Patient';
import Reports from '../pages/reports/Reports';
import Statistics from '../pages/statistics/Statistics';
import Company from '../pages/company/Company'
import CompanyUsers from '../pages/company-users/CompanyUsers';
import Whatsapp from '../pages/company/whatsapp';
import GoogleBusiness from '../pages/company/areas/googleBusiness/GoogleBusiness';
import CompanyRooms from '../pages/company/areas/rooms/CompanyRooms';
import CompanyInsurance from '../pages/company/areas/insurance/CompanyInsurance';
import FiscalSettings from '../pages/company/areas/fiscalSettings/FiscalSettings';
import CompanyAudit from '../pages/company/audit/CompanyAudit';
import Logout from '../pages/logout/Logout';
import NPSForm from '../pages/nps/NPSForm';
import Financial from '../pages/financial/Financial';
import ResourcesPage from '../pages/resources';
import ProceduresPage from '../pages/procedures';
import AppointmentTypesPage from '../pages/appointment-types';
import AppointmentStepsPage from '../pages/appointment-steps/AppointmentStepsPage';
import PaymentMethodsPage from '../pages/payment-methods';
import Packages from '../pages/packages/Packages';
import Templates from '../pages/templates/Templates';
import Preferences from '../pages/preferences/Preferences';
import SetupWizard from '../pages/setup-wizard/SetupWizard';
import Profile from '../pages/profile';
import Plans from '../pages/subscription/plans/Plans';
import SubscriptionDetails from '../pages/subscription/details/SubscriptionDetails';
import Referral from '../pages/referral/Referral';
import Success from '../pages/subscription/stripe/Success';
import Canceled from '../pages/subscription/stripe/Canceled';
import BudgetGeneratePage from '../pages/budgets/BudgetGeneratePage';
import AISimulatorPage from '../pages/ai-simulator/AISimulatorPage';
import CranialAnalysisPage from '../pages/tools/cranial-analysis/CranialAnalysisPage';
import AISettings from '../pages/company/areas/aiSettings/AISettings';
import AdminCompanies from '../pages/admin/companies/AdminCompanies';
import AdminCompanyDetails from '../pages/admin/companies/AdminCompanyDetails';
import AdminFeedbacks from '../pages/admin/feedbacks/AdminFeedbacks';
import AdminBlockedIps from '../pages/admin/security/AdminBlockedIps';
import AdminLogs from '../pages/admin/logs/AdminLogs';
import AdminCrons from '../pages/admin/crons/AdminCrons';
import AdminBackups from '../pages/admin/backups/AdminBackups';
import AdminAudit from '../pages/admin/audit/AdminAudit';
import AdminSubscriptions from '../pages/admin/subscriptions/AdminSubscriptions';
import AdminWhatsApp from '../pages/admin/whatsapp/AdminWhatsApp';
import AdminWhatsAppOutbox from '../pages/admin/whatsapp-outbox/AdminWhatsAppOutbox';
import AdminSignups from '../pages/admin/signups/AdminSignups';
import AdminTrialOutreach from '../pages/admin/trial-outreach/AdminTrialOutreach';
import AdminProspects from '../pages/admin/prospects/AdminProspects';
import AdminTutorials from '../pages/admin/tutorials/AdminTutorials';
import AdminChangelog from '../pages/admin/changelog/AdminChangelog';
import AdminOnboarding from '../pages/admin/onboarding/AdminOnboarding';

import IconDashboard from '@mui/icons-material/SpaceDashboardOutlined';
import IconLeads from '@mui/icons-material/GroupsOutlined';
import IconCalendar from '@mui/icons-material/CalendarMonthOutlined';
import IconPatients from '@mui/icons-material/PeopleAltOutlined';
import IconStatistics from '@mui/icons-material/BarChartOutlined';
import IconReports from '@mui/icons-material/DocumentScannerOutlined';
import IconCompany from '@mui/icons-material/ApartmentOutlined';
import IconBusiness from '@mui/icons-material/LibraryBooksOutlined';
import IconResources from '@mui/icons-material/Person2Outlined';
import IconServices from '@mui/icons-material/DesignServicesOutlined';
import IconAppointmentTypes from '@mui/icons-material/ViewModuleOutlined';
import IconAppointmentSteps from '@mui/icons-material/ChecklistRtlOutlined';
import IconUsers from '@mui/icons-material/GroupOutlined';
import IconSettings from '@mui/icons-material/TuneOutlined';
import IconLogout from '@mui/icons-material/LogoutOutlined';
import IconWhatsapp from '@mui/icons-material/WhatsApp';
import IconWaitingList from '@mui/icons-material/HourglassEmptyOutlined';
import IconRecovery from '@mui/icons-material/EventRepeatOutlined';
import IconFinancial from '@mui/icons-material/MonetizationOnOutlined';
import IconAttachMoney from '@mui/icons-material/AttachMoneyOutlined';
import IconHome from '@mui/icons-material/HomeOutlined';
import IconMarketing from '@mui/icons-material/CampaignOutlined';
import IconSourceOutlined from '@mui/icons-material/SourceOutlined';
import IconAnalytics from '@mui/icons-material/InsightsOutlined';
import IconConfig from '@mui/icons-material/TuneOutlined';
import IconSystem from '@mui/icons-material/AdminPanelSettingsOutlined';
import IconPreferences from '@mui/icons-material/SettingsOutlined';
import IconTemplates from '@mui/icons-material/DescriptionOutlined';
import IconPackages from '@mui/icons-material/LocalOfferOutlined';
import IconSchedule from '@mui/icons-material/EventNoteOutlined';
import IconPayment from '@mui/icons-material/PaymentOutlined';
import IconReferral from '@mui/icons-material/CardGiftcardOutlined';
import IconUpload from '@mui/icons-material/UploadFileOutlined';
import IconAdminAudit from '@mui/icons-material/HistoryOutlined';
import IconCompanyAudit from '@mui/icons-material/FactCheckOutlined';
import IconBackup from '@mui/icons-material/BackupOutlined';
import IconSystemConfig from '@mui/icons-material/SettingsSuggestOutlined';
import IconProfile from '@mui/icons-material/AccountCircleOutlined';
import IconInfo from '@mui/icons-material/InfoOutlined';
import IconTutorials from '@mui/icons-material/SchoolOutlined';
import IconChangelog from '@mui/icons-material/AutoAwesomeOutlined';
import IconNotifications from '@mui/icons-material/NotificationsOutlined';
import IconGoogleBusiness from '@mui/icons-material/Google';
import IconIntegrations from '@mui/icons-material/IntegrationInstructionsOutlined';
import IconRooms from '@mui/icons-material/MeetingRoomOutlined';
import IconInsurance from '@mui/icons-material/BadgeOutlined';
import IconFiscal from '@mui/icons-material/ReceiptLongOutlined';
import IconBudget from '@mui/icons-material/RequestQuoteOutlined';
import IconAISimulator from '@mui/icons-material/SmartToyOutlined';
import IconCranialAnalysis from '@mui/icons-material/StraightenOutlined';
import IconAdminPanel from '@mui/icons-material/AdminPanelSettings';
import IconBeta from '@mui/icons-material/ScienceOutlined';
import IconAdminFeedbacks from '@mui/icons-material/RateReviewOutlined';
import IconAdminBlockedIps from '@mui/icons-material/BlockOutlined';
import IconAdminLogs from '@mui/icons-material/ArticleOutlined';
import IconAdminCrons from '@mui/icons-material/ScheduleOutlined';
import IconAdminBackups from '@mui/icons-material/BackupOutlined';
import IconAdminSubscriptions from '@mui/icons-material/CreditCardOutlined';
import IconAdminWhatsApp from '@mui/icons-material/WhatsApp';
import IconAdminWhatsAppOutbox from '@mui/icons-material/ScheduleSend';
import IconAdminSignups from '@mui/icons-material/MarkEmailUnreadOutlined';
import IconAdminTrialOutreach from '@mui/icons-material/ForumOutlined';
import IconAdminProspects from '@mui/icons-material/PersonSearchOutlined';
import IconAdminTutorials from '@mui/icons-material/SchoolOutlined';
import IconAdminChangelog from '@mui/icons-material/AutoAwesomeOutlined';
import IconAdminOnboarding from '@mui/icons-material/MarkEmailReadOutlined';

export const IdLogin = "login";
export const IdDashboard = "dashboard";
export const IdLeads = "leads";
export const IdWhatsappMessages = "whatsapp";
export const IdSchedule = "schedule";
export const IdSchedule_Appointments = "schedule/appointments";
export const IdAppointment = "schedule/appointments/appointment";
export const IdWaitingList = "schedule/waitingList";
export const IdRecovery = "intelligence/recovery";
export const IdInvoice = "invoice";
export const IdDocument = "document";
export const IdPatients = "patients";
export const IdPatients_Patient = "patients/patient";
export const IdStatistics = "statistics";
export const IdReports = "reports";
export const IdCompany = "company";
export const IdCompanyUsers = "company/users";
export const IdCompanyWhatsapp = "company/whatsapp";
export const IdCompanyGoogleBusiness = "company/google-business";
export const IdCompanyRooms = "company/rooms";
export const IdCompanyInsurance = "company/insurance";
export const IdCompanyFiscalSettings = "company/fiscal-settings";
export const IdCompanyAudit = "company/audit";
export const IdResources = "resources";
export const IdProcedures = "procedures";
export const IdAppointmentTypes = "appointment-types";
export const IdAppointmentSteps = "appointment-steps";
export const IdPaymentMethods = "payment-methods";
export const IdSettings = "settings";
export const IdLogout = "logout";
export const IdNPSForm = "nps-form";
export const IdFinancial = "financial";
export const IdPreferences = "preferences";
export const IdTemplates = "templates";
export const IdPackages = "packages";
export const IdSystemImport = "system/import";
export const IdSystemExport = "system/export";
export const IdSystemConfig = "system/about";
export const IdSystemTutorials = "system/tutorials";
export const IdSystemChangelog = "system/novidades";
export const IdNotifications = "notifications";
export const IdSetupWizard = "setup-wizard";
export const IdProfile = "profile";
export const IdMarketingCampaigns = "marketing/campaigns";
export const IdMarketingSources = "marketing/leads-origins";
export const IdMarketingMassMessaging = "marketing/mass-messaging";
export const IdSubscriptionPlans = "subscription/plans";
export const IdSubscriptionDetails = "subscription/details";
export const IdReferral = "referral";
export const IdSubscriptionStripeSuccess = "subscription/stripe/success";
export const IdSubscriptionStripeCanceled = "subscription/stripe/canceled";
export const IdTermsPrivacy = "system/terms-privacy";
export const IdBudgets = "budgets";
export const IdAISimulator = "ai/simulator";
export const IdCranialAnalysisTool = "tools/cranial-analysis";
export const IdCompanyAISettings = "company/ai-settings";
export const IdAdminCompanies = "admin/companies";
export const IdAdminCompanyDetails = "admin/companies/:id";
export const IdAdminFeedbacks = "admin/feedbacks";
export const IdAdminTutorials = "admin/tutorials";
export const IdAdminChangelog = "admin/changelog";
export const IdAdminOnboarding = "admin/onboarding";
export const IdAdminBlockedIps = "admin/blocked-ips";
export const IdAdminLogs = "admin/logs";
export const IdAdminCrons = "admin/crons";
export const IdAdminBackups = "admin/backups";
export const IdAdminAudit = "admin/audit";
export const IdAdminSubscriptions = "admin/subscriptions";
export const IdAdminWhatsApp = "admin/whatsapp";
export const IdAdminWhatsAppOutbox = "admin/whatsapp-outbox";
export const IdAdminSignups = "admin/signups";
export const IdAdminTrialOutreach = "admin/trial-outreach";
export const IdAdminProspects = "admin/prospects";

const AppConfig = {
  MinScreenSizeX: 1010,
  Routes:
    [
      {
        id: IdLogin,
        path: "/login",
        label: "Login",
        element: <Login />,
      },
      {
        id: IdDashboard,
        path: "/dashboard",
        label: "Início",
        element: <Dashboard />,
        icon: <IconDashboard fontSize='small'/>,
      },
      {
        id: IdLeads,
        path: "/leads",
        label: "Leads",
        element: <Leads />,
        icon: <IconLeads fontSize='small'/>,
      },
      {
        id: IdMarketingCampaigns,
        path: "/marketing/campaigns",
        label: "Campanhas",
        element: <Campaigns />,
        icon: <IconMarketing fontSize='small'/>,
      },
      {
        id: IdMarketingSources,
        path: "/marketing/leads-origins",
        label: "Origens",
        element: <Sources />,
        icon: <IconSourceOutlined fontSize='small'/>,
      },
      {
        id: IdMarketingMassMessaging,
        path: "/marketing/mass-messaging",
        label: "Envio em Massa",
        element: <MassMessaging />,
        icon: <IconMarketing fontSize='small'/>,
      },
      {
        id: IdWhatsappMessages,
        path: "/whatsapp",
        label: "Conversas WhatsApp",
        element: <WhatsappMessages />,
        icon: <IconWhatsapp fontSize='small'/>,
        // Tela do copiloto de IA: visível só para administradores da plataforma
        // enquanto a IA estiver restrita (LGPD L-07). Para abrir às clínicas,
        // remover platformAdminOnly.
        platformAdminOnly: true,
      },
      {
        id: IdSchedule_Appointments,
        path: "/schedule/appointments",
        label: "Agendamentos",
        element: <Appointments />,
        icon: <IconCalendar fontSize='small'/>,
      },
      {
        id: IdWaitingList,
        path: "/schedule/waitingList",
        label: "Lista de espera",
        element: <WaitingListV2Page />,
        icon: <IconWaitingList fontSize='small'/>,
      },
      {
        // Recuperar atendimentos: beta visível só para administradores da
        // plataforma. Para abrir às clínicas, remover platformAdminOnly aqui e
        // requirePlatformAdmin() nos endpoints de public/api/intelligence/recovery.
        id: IdRecovery,
        path: "/intelligence/recovery",
        label: "Recuperar atendimentos",
        element: <RecoveryPage />,
        icon: <IconRecovery fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAppointment,
        path: "/appointment/:id",
        label: "Consulta",
        element: <Appointment fontSize='small'/>,
      },
      {
        id: IdInvoice,
        path: "/invoice/:id",
        label: "Recibo",
        element: <Invoice fontSize='small'/>,
      },
      {
        id: IdDocument,
        path: "/document/:id",
        label: "Documento",
        element: <Document fontSize='small'/>,
      },
      {
        id: IdPatients,
        path: "/patients",
        label: "Pacientes",
        element: <Patients />,
        icon: <IconPatients fontSize='small'/>,
      },
      {
        id: IdPatients_Patient,
        path: "/patients/:id",
        label: "Paciente",
        element: <Patient />,
      },
      {
        id: IdFinancial,
        path: "/financial",
        label: "Financeiro",
        element: <Financial />,
        icon: <IconFinancial fontSize='small'/>,
      },
      {
        id: IdStatistics,
        path: "/statistics",
        label: "Estatísticas",
        element: <Statistics />,
        icon: <IconStatistics fontSize='small'/>,
      },
      {
        id: IdReports,
        path: "/reports",
        label: "Relatórios",
        element: <Reports />,
        icon: <IconReports fontSize='small'/>,
      },
      {
        id: IdCompany,
        path: "/company/registration-data",
        label: "Dados cadastrais",
        element: <Company />,
        icon: <IconCompany fontSize='small'/>,
      },
      {
        id: IdCompanyWhatsapp,
        path: "/company/whatsapp",
        label: "WhatsApp",
        element: <Whatsapp />,
        icon: <IconWhatsapp fontSize='small'/>,
      },
      {
        id: IdCompanyUsers,
        path: "/company/users",
        label: "Usuários",
        element: <CompanyUsers />,
        icon: <IconUsers fontSize='small'/>,
      },
      {
        id: IdCompanyAudit,
        path: "/company/audit",
        label: "Auditoria",
        element: <CompanyAudit />,
        icon: <IconCompanyAudit fontSize='small'/>,
        ownerOnly: true,
      },
      {
        id: IdCompanyGoogleBusiness,
        path: "/company/google-business",
        label: "Google Meu Negócio",
        element: <GoogleBusiness />,
        icon: <IconGoogleBusiness fontSize='small'/>,
      },
      {
        id: IdCompanyRooms,
        path: "/company/rooms",
        label: "Salas",
        element: <CompanyRooms />,
        icon: <IconRooms fontSize='small'/>,
      },
      {
        id: IdCompanyFiscalSettings,
        path: "/company/fiscal-settings",
        label: "Nota Fiscal (NFS-e)",
        element: <FiscalSettings />,
        icon: <IconFiscal fontSize='small'/>,
      },
      {
        id: IdPreferences,
        path: "/company/preferences",
        label: "Preferências",
        element: <Preferences />,
        icon: <IconPreferences fontSize='small'/>,
      },
      {
        id: IdResources,
        path: "/company/agendas",
        label: "Agendas",
        element: <ResourcesPage />,
        icon: <IconResources fontSize='small'/>,
      },
      {
        id: IdProcedures,
        path: "/company/procedures",
        label: "Procedimentos",
        element: <ProceduresPage />,
        icon: <IconServices fontSize='small'/>,
      },
      {
        id: IdCompanyInsurance,
        path: "/company/insurance",
        label: "Convênios",
        element: <CompanyInsurance />,
        icon: <IconInsurance fontSize='small'/>,
      },
      {
        id: IdAppointmentTypes,
        path: "/company/appointment-types",
        label: "Tipos de atendimento",
        element: <AppointmentTypesPage />,
        icon: <IconAppointmentTypes fontSize='small'/>,
      },
      {
        id: IdAppointmentSteps,
        path: "/company/appointment-steps",
        label: "Etapas do atendimento",
        element: <AppointmentStepsPage />,
        icon: <IconAppointmentSteps fontSize='small'/>,
      },
      {
        id: IdPaymentMethods,
        path: "/company/payment-methods",
        label: "Métodos de Pagamento",
        element: <PaymentMethodsPage />,
        icon: <IconPayment fontSize='small'/>,
      },
      {
        id: IdPackages,
        path: "/company/packages",
        label: "Pacotes",
        element: <Packages />,
        icon: <IconPackages fontSize='small'/>,
      },
      {
        id: IdTemplates,
        path: "/company/templates",
        label: "Modelos",
        element: <Templates />,
        icon: <IconTemplates fontSize='small'/>,
      },
      {
        id: IdLogout,
        path: "/logout",
        label: "Sair",
        icon: <IconLogout fontSize='small'/>,
        element: <Logout />,
      },
      {
        id: IdNPSForm,
        path: "/nps-form/:id",
        label: "Formulário NPS",
        element: <NPSForm />,
      },
      {
        id: IdSystemImport,
        path: "/system/import",
        label: "Importar Dados",
        element: <Import />,
        icon: <IconUpload fontSize='small'/>,
      },
      {
        id: IdSystemExport,
        path: "/system/backup",
        label: "Backup e dados",
        element: <Export />,
        icon: <IconBackup fontSize='small'/>,
      },
      {
        id: IdSystemConfig,
        path: "/system/about",
        label: "Sobre o Sistema",
        element: <About />,
        icon: <IconInfo fontSize='small'/>,
      },
      {
        id: IdSystemTutorials,
        path: "/system/tutorials",
        label: "Tutoriais",
        element: <Tutorials />,
        icon: <IconTutorials fontSize='small'/>,
      },
      {
        id: IdSystemChangelog,
        path: "/system/novidades",
        label: "Novidades",
        element: <ChangelogPage />,
        icon: <IconChangelog fontSize='small'/>,
      },
      {
        id: IdNotifications,
        path: "/notifications",
        label: "Notificações",
        element: <Notifications />,
        icon: <IconNotifications fontSize='small'/>,
      },
      {
        id: IdSetupWizard,
        path: "/setup-wizard",
        label: "Configuração da Empresa",
        element: <SetupWizard />,
      },
      {
        id: IdProfile,
        path: "/profile",
        label: "Meu Perfil",
        element: <Profile />,
        icon: <IconProfile fontSize='small'/>,
      },
      {
        id: IdSubscriptionPlans,
        path: "/subscription/plans",
        label: "Planos de Assinatura",
        element: <Plans />,
        icon: <IconPayment fontSize='small'/>,
      },
      {
        id: IdSubscriptionDetails,
        path: "/subscription/details",
        label: "Detalhes da Assinatura",
        element: <SubscriptionDetails />,
        icon: <IconInfo fontSize='small'/>,
      },
      {
        id: IdReferral,
        path: "/indique",
        label: "Indique e ganhe",
        element: <Referral />,
        icon: <IconReferral fontSize='small'/>,
      },
      {
        id: IdSubscriptionStripeSuccess,
        path: "/subscription/stripe/success",
        label: "Assinatura Confirmada",
        element: <Success />,
      },
      {
        id: IdSubscriptionStripeCanceled,
        path: "/subscription/stripe/canceled",
        label: "Pagamento não concluído",
        element: <Canceled />,
      },
      {
        id: IdTermsPrivacy,
        path: "/system/terms-privacy",
        label: "Termos de Uso e Política de Privacidade",
        element: <TermsPrivacy />,
        icon: <IconInfo fontSize='small'/>,
      },
      {
        id: IdBudgets,
        path: "/budgets/generate",
        label: "Orçamentos",
        element: <BudgetGeneratePage />,
        icon: <IconBudget fontSize='small'/>,
      },
      // Assistente de IA restrito a administradores da plataforma (LGPD, L-07)
      // até haver garantia contratual do provedor de IA. Para abrir às
      // clínicas: remover platformAdminOnly aqui, a condição em
      // whatsappMessages/WhatsappMessages.js e requirePlatformAdmin() nos
      // endpoints de public/api/ai-simulator e whatsapp/suggest_reply.php.
      {
        id: IdAISimulator,
        path: "/ai/simulator",
        label: "Simulador de IA",
        element: <AISimulatorPage />,
        icon: <IconAISimulator fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        // Análise craniana por foto: beta visível só para administradores da
        // plataforma (seção Beta do menu). Para abrir às clínicas, remover
        // platformAdminOnly aqui e requirePlatformAdmin() em
        // public/api/tools/cranial-analysis/analyze.php.
        id: IdCranialAnalysisTool,
        path: "/tools/cranial-analysis",
        label: "Análise craniana por foto",
        element: <CranialAnalysisPage />,
        icon: <IconCranialAnalysis fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdCompanyAISettings,
        path: "/company/ai-settings",
        label: "Assistente de IA",
        element: <AISettings />,
        icon: <IconAISimulator fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminCompanies,
        path: "/admin/companies",
        label: "Empresas",
        element: <AdminCompanies />,
        icon: <IconAdminPanel fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminCompanyDetails,
        path: "/admin/companies/:id",
        label: "Detalhes da Empresa",
        element: <AdminCompanyDetails />,
        platformAdminOnly: true,
      },
      {
        id: IdAdminFeedbacks,
        path: "/admin/feedbacks",
        label: "Feedbacks e NPS",
        element: <AdminFeedbacks />,
        icon: <IconAdminFeedbacks fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminTutorials,
        path: "/admin/tutorials",
        label: "Tutoriais",
        element: <AdminTutorials />,
        icon: <IconAdminTutorials fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminChangelog,
        path: "/admin/changelog",
        label: "Novidades",
        element: <AdminChangelog />,
        icon: <IconAdminChangelog fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminOnboarding,
        path: "/admin/onboarding",
        label: "Acompanhamento",
        element: <AdminOnboarding />,
        icon: <IconAdminOnboarding fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminBlockedIps,
        path: "/admin/blocked-ips",
        label: "IPs bloqueados",
        element: <AdminBlockedIps />,
        icon: <IconAdminBlockedIps fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminLogs,
        path: "/admin/logs",
        label: "Logs",
        element: <AdminLogs />,
        icon: <IconAdminLogs fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminCrons,
        path: "/admin/crons",
        label: "Rotinas",
        element: <AdminCrons />,
        icon: <IconAdminCrons fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminBackups,
        path: "/admin/backups",
        label: "Backups",
        element: <AdminBackups />,
        icon: <IconAdminBackups fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminAudit,
        path: "/admin/audit",
        label: "Auditoria",
        element: <AdminAudit />,
        icon: <IconAdminAudit fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminSubscriptions,
        path: "/admin/subscriptions",
        label: "Assinaturas",
        element: <AdminSubscriptions />,
        icon: <IconAdminSubscriptions fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminWhatsApp,
        path: "/admin/whatsapp",
        label: "WhatsApp",
        element: <AdminWhatsApp />,
        icon: <IconAdminWhatsApp fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminWhatsAppOutbox,
        path: "/admin/whatsapp-outbox",
        label: "Fila WhatsApp",
        element: <AdminWhatsAppOutbox />,
        icon: <IconAdminWhatsAppOutbox fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminSignups,
        path: "/admin/signups",
        label: "Cadastros pendentes",
        element: <AdminSignups />,
        icon: <IconAdminSignups fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminTrialOutreach,
        path: "/admin/trial-outreach",
        label: "Contato com testes",
        element: <AdminTrialOutreach />,
        icon: <IconAdminTrialOutreach fontSize='small'/>,
        platformAdminOnly: true,
      },
      {
        id: IdAdminProspects,
        path: "/admin/prospects",
        label: "Prospecção",
        element: <AdminProspects />,
        icon: <IconAdminProspects fontSize='small'/>,
        platformAdminOnly: true,
      }
    ],
  MenuRoutes: [
    {
      label: "Geral",
      icon: <IconHome fontSize='small'/>,
      routes: [
        IdDashboard,
        IdPatients,
      ]
    },
    {
      label: "Agenda",
      icon: <IconSchedule fontSize='small'/>,
      routes: [
        IdSchedule_Appointments,
        IdWaitingList,
      ]
    },
    {
      label: "Financeiro",
      icon: <IconAttachMoney fontSize='small'/>,
      routes: [
        IdFinancial,
        IdBudgets,
        IdPaymentMethods,
      ]
    },
    {
      label: "Marketing",
      icon: <IconMarketing fontSize='small'/>,
      routes: [
        IdLeads,
        IdMarketingCampaigns,
        IdMarketingSources,
        IdMarketingMassMessaging,
      ]
    },
    {
      label: "Análises",
      icon: <IconAnalytics fontSize='small'/>,
      routes: [
        IdStatistics,
        IdReports,
      ]
    },
    {
      label: "Cadastros",
      icon: <IconBusiness fontSize='small'/>,
      routes: [
        IdCompanyUsers,
        IdResources,
        IdCompanyRooms,
        IdProcedures,
        IdCompanyInsurance,
        IdAppointmentTypes,
        IdAppointmentSteps,
        IdPackages,
      ]
    },
    {
      label: "Configurações",
      icon: <IconPreferences fontSize='small'/>,
      routes: [
        IdCompany,
        IdPreferences,
        IdCompanyAudit,
        IdTemplates,
      ]
    },
    {
      label: "Integrações",
      icon: <IconIntegrations fontSize='small'/>,
      routes: [
        IdCompanyWhatsapp,
        IdCompanyFiscalSettings,
        IdCompanyGoogleBusiness,
      ]
    },
    {
      label: "Assinatura",
      icon: <IconPayment fontSize='small'/>,
      routes: [
        IdSubscriptionPlans,
        IdSubscriptionDetails,
        IdReferral,
      ]
    },
    {
      label: "Sistema",
      icon: <IconSystem fontSize='small'/>,
      routes: [
        IdSystemImport,
        IdSystemExport,
        IdSystemTutorials,
        IdSystemChangelog,
        IdTermsPrivacy,
        IdSystemConfig,
      ]
    },
    {
      label: "Conta",
      icon: <IconProfile fontSize='small'/>,
      routes: [
        IdProfile,
        IdLogout,
      ]
    },
    {
      // Beta: funcionalidades em teste, visíveis só para administradores da
      // plataforma (rotas com platformAdminOnly). Quando uma delas abrir às
      // clínicas, mover o id para a seção do seu assunto (Agenda, Marketing,
      // Configurações...) e remover platformAdminOnly na rota.
      label: "Beta",
      icon: <IconBeta fontSize='small'/>,
      routes: [
        IdRecovery,
        IdWhatsappMessages,
        IdCompanyAISettings,
        IdAISimulator,
        IdCranialAnalysisTool,
      ]
    },
    {
      label: "Admin Geral",
      icon: <IconAdminPanel fontSize='small'/>,
      routes: [
        IdAdminCompanies,
        IdAdminSubscriptions,
        IdAdminTrialOutreach,
        IdAdminProspects,
        IdAdminWhatsApp,
        IdAdminWhatsAppOutbox,
        IdAdminSignups,
        IdAdminFeedbacks,
        IdAdminTutorials,
        IdAdminChangelog,
        IdAdminOnboarding,
        IdAdminBlockedIps,
        IdAdminLogs,
        IdAdminCrons,
        IdAdminBackups,
        IdAdminAudit,
      ]
    },
  ],
  GetRouteById: (id) => {
    return AppConfig.Routes.find((route) => {
      return route.id == id;
    })
  },
  GetRouteLabel: (path) => {
    return AppConfig.Routes.find((route) => {
      return route.path == path;
    })
  },
}

export default AppConfig;